import './FourBySixLabel.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Logger from '@KrashidBuilt/common/utils/logger';
import { LabelColorBand, LabelFields, LabelHeader, LabelInspectedBy, LabelPartImage } from '../../components';
import { ENVIRONMENT, LABEL_SIZE_MAP } from '../../constants';

const logger = new Logger('FourBySixLabel');

/**
 * FourBySixLabel Component
 * @augments {Component<Props, State>}
 */
class FourBySixLabel extends Component {
    render() {
        logger.extra({ _: this });
        const { part, fields, showEmpty, rotate, hashId, qrDisabled, qrHintDisabled } = this.props;

        return (
            <div className={`FourBySixLabel ${rotate ? 'rotate' : ''}`}>
                <LabelHeader {...this.props} />
                {(ENVIRONMENT != 'production') && <p className='PartId'>{part?.id}</p>}
                <LabelPartImage part={part} size={LABEL_SIZE_MAP._4x6} qrDisabled={qrDisabled} hashId={hashId} qrHintDisabled={qrHintDisabled} />
                <LabelColorBand {...this.props} size={LABEL_SIZE_MAP._4x6} />
                <LabelFields size={LABEL_SIZE_MAP._4x6} fields={fields} showEmpty={showEmpty} hashId={hashId} partId={part.id} />
                <LabelInspectedBy size={LABEL_SIZE_MAP._4x6} />
            </div>
        );
    }
}

FourBySixLabel.defaultProps = {
    rotate: true,
    showEmpty: false,
};

FourBySixLabel.propTypes = {
    rotate: PropTypes.bool,
    qrDisabled: PropTypes.bool,
    qrHintDisabled: PropTypes.bool,
    showEmpty: PropTypes.bool,
    part: PropTypes.shape(),
    hashId: PropTypes.string,
    fields: PropTypes.array,
};


export default FourBySixLabel;